import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import moment from "moment";
import { toast } from "react-toastify";
import { spinnerService } from "@chevtek/react-spinners";
import * as mutations from "../graphql/mutations";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import gql from "graphql-tag";

const CustomTableCell = withStyles(theme => ({
  head: {
    //backgroundColor: "black",
    color: "black",
    fontSize: 14,
    marginTop: "0px"
  },
  body: {
    fontSize: 14
  }
}))(TableCell);

class EnhancedTableHead extends React.Component {
  render() {
    return (
      <TableHead>
        <TableRow>
          {this.props.heads.map(
            row => (
              <CustomTableCell key={row.id} padding="checkbox">
                {row.label}
              </CustomTableCell>
            ),
            this
          )}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  // onRequestSort: PropTypes.func.isRequired,
  // order: PropTypes.string.isRequired,
  // orderBy: PropTypes.string.isRequired,
  // rowCount: PropTypes.number.isRequired
};

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 1
  },
  table: {
    // maxWidth: "100%"
  },
  tableWrapper: {
    overflowX: "auto"
  }
});

class DataTable extends React.Component {
  state = {
    order: "asc",
    orderBy: "defects",
    data: this.props.rows,
    heads: this.props.heads,
    table: this.props.table,
    page: 0,
    rowsPerPage: 5,
    searching: false,
    searchArr: [],
    del: "",
    open: false
  };
  componentDidMount() {
    
    if (this.state.table === "general") {
      this.setState({
        rowsPerPage: 10
      });
    }
  }
  componentWillUnmount() {
    this.setState({
      data: []
    });
  }

  filterVehicles = e => {
    this.setState({
      searching: true,
      searchArr: this.state.data.filter(arr =>
        arr.customerVehicleId.toLowerCase().includes(e.toLowerCase())
      )
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property && this.state.order === "desc") {
      order = "asc";
    }

    this.setState({ order, orderBy });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;
  handleDeleteVehicle = async id => {
    if (this.state.del !== "") {
      try {
        spinnerService.show("mySpinner");
        await this.props.client.mutate({
          mutation: gql(mutations.deleteVehicle),
          variables: {
            input: {
              id
            }
          }
        });
        this.setState(
          {
            data: this.state.data.filter(dt => dt.id !== id),
            open: false,
            del: ""
          },
          () => {
            this.props.loadData();
            spinnerService.hide("mySpinner");
          }
        );
        toast.success("Vehicle Deleted Successfully");
      } catch (err) {
        toast.error("Vehicle Deletion Failed");
        alert(err);
        spinnerService.hide("mySpinner");
      }
    } else {
      toast.error("Something Went Wrong");
    }
  };
  render() {
    const { classes } = this.props;
    let {
      data,
      order,
      orderBy,
      rowsPerPage,
      page,
      searching,
      searchArr,
      heads
    } = this.state;

    if (searching) {
      data = searchArr;
    }
    data = data.sort((a, b) => {
      if (a.nextInspectionDue && b.nextInspectionDue) {
        return (
          moment(a.nextInspectionDue[0].nextDueDate) -
          moment(b.nextInspectionDue[0].nextDueDate)
        );
      }
    });
    let tempRowsPerPage = rowsPerPage;
    const DialogScreen = (
      <Dialog
        open={this.state.open}
        onClose={() => this.setState({ open: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            width: 365,
            background: "linear-gradient(60deg, #ab47bc, #8e24aa)",
            color: "white"
          }}
        >
          {"Do you want to update"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ padding: 24, paddingBottom: 0, fontWeight: "bold" }}
            className="color-danger"
          >
            Do You Want To Delete Vehicle ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => this.setState({ open: false })}
            color="primary"
            className="bg-light text-dark"
          >
            Cancel
          </Button>
          <Button
            onClick={() => this.handleDeleteVehicle(this.state.del)}
            color="error"
            className="bg-error"
            autoFocus
          >
            Yes, Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
    return (
      <Paper className={classes.root}>
        {DialogScreen}
        <div className={classes.tableWrapper}>
          {this.state.table === "general" && (
            <div style={{ margin: 3 }}>
              <input
                type="text"
                className="form-control"
                onChange={e => this.filterVehicles(e.target.value)}
                placeholder="Search Vehicle By ID"
                style={{ height: 35, width: 250 }}
              />
            </div>
          )}
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            padding="checkbox"
          >
            <EnhancedTableHead
              heads={heads}
              // order={order}
              // orderBy={orderBy}
              // onRequestSort={this.handleRequestSort}
              // rowCount={data.length}
            />
            {data.length > 0 ? (
              <TableBody>
                {/* stableSort(data, getSorting(order, orderBy)) */}
                {data
                  .slice(
                    page * tempRowsPerPage,
                    page * tempRowsPerPage + tempRowsPerPage
                  )
                  .map(n => {
                    return (
                      <TableRow hover key={n.customerVehicleId}>
                        <CustomTableCell component="th" scope="row">
                          {/* <Chip
                            style={{
                              height: "20px",
                              width: "10px",
                              marginRight: "4px"
                              backgroundColor: n.redTag
                                ? "red"
                                : !n.redTag &&
                                  n.defectCount > 0 &&
                                  moment(
                                    new Date(n.nextInspectionDue[0].nextDueDate)
                                  ).diff(new Date(), "days") > 0
                                ? "yellow"
                                : !n.redTag &&
                                  moment(
                                    new Date(n.nextInspectionDue[0].nextDueDate)
                                  ).diff(new Date(), "days") < 0
                                ? "purple"
                                : !n.redTag &&
                                  n.defectCount === 0 &&
                                  moment(
                                    new Date(n.nextInspectionDue[0].nextDueDate)
                                  ).diff(new Date(), "days") < 11 &&
                                  moment(
                                    new Date(n.nextInspectionDue[0].nextDueDate)
                                  ).diff(new Date(), "days") > 0
                                ? "#87CEFA"
                                : "green"
                            }}
                          /> */}
                          <Link
                            to={{
                              pathname: ["vendor", "mech"].includes(
                                this.state.table
                              )
                                ? `/${this.state.table}/customer/${n.customer}/vehicle/${n.id}`
                                : `company/vehicle/${n.id}`,
                              focus: null
                              // client: { client }
                            }}
                          >
                            {n.customerVehicleId}
                          </Link>
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          {n.make}
                        </CustomTableCell>
                        <CustomTableCell align="right">
                          {n.model}
                        </CustomTableCell>
                        {/* <CustomTableCell align="right">{n.VIN}</CustomTableCell> */}
                        <CustomTableCell align="right">
                          <div>
                            {n.VIN.slice(0, 9).toString()}
                            <strong
                              style={{ fontSize: 18, fontWeight: "bolder" }}
                            >
                              {n.VIN.slice(9, 11).toString()}
                            </strong>
                            <strong
                              style={{ fontSize: 18, fontWeight: "bolder" }}
                            >
                              <i>{n.VIN.slice(11, 17).toString()}</i>
                            </strong>
                          </div>
                        </CustomTableCell>
                        {["general", "inspections", "vendor", "mech"].includes(
                          this.state.table
                        ) && (
                          <CustomTableCell align="right">
                            <Link
                              to={{
                                pathname: ["vendor", "mech"].includes(
                                  this.state.table
                                )
                                  ? `/${this.state.table}/customer/${n.customer}/vehicle/${n.id}`
                                  : `company/vehicle/${n.id}`,
                                focus: "Insp"
                                // client: { client }
                              }}
                            >
                              <Typography
                                style={{
                                  color: "blue"
                                }}
                                variant={
                                  moment(new Date(n.nextDue)).diff(
                                    new Date(),
                                    "days"
                                  ) < 3 &&
                                  moment(new Date(n.nextDue)).diff(
                                    new Date(),
                                    "days"
                                  ) >= 0
                                    ? "body2"
                                    : "body1"
                                }
                              >
                                {n.nextDue}
                              </Typography>
                            </Link>
                            {/* <Link
                              to={{
                                pathname: `company/vehicle/${n.id}`,
                                focus: "Insp"
                                // client: { client }
                              }}
                            >
                              {["", null, undefined].includes(
                                n.nextInspectionDue
                              ) === false && n.nextInspectionDue.length > 0
                                ? n.nextInspectionDue.length === 1
                                  ? moment(
                                      n.nextInspectionDue[0].nextDueDate
                                    ).format("MM-DD-YYYY")
                                  : n.nextInspectionDue.length === 2 &&
                                    moment(
                                      new Date(
                                        n.nextInspectionDue[1].nextDueDate
                                      )
                                    ).isBefore(
                                      new Date(
                                        n.nextInspectionDue[0].nextDueDate
                                      )
                                    )
                                  ? moment(
                                      n.nextInspectionDue[1].nextDueDate
                                    ).format("MM-DD-YYYY")
                                  : moment(
                                      n.nextInspectionDue[0].nextDueDate
                                    ).format("MM-DD-YYYY")
                                : ""}
                            </Link> */}
                          </CustomTableCell>
                        )}
                        {["defects", "general", "vendor", "mech"].includes(
                          this.state.table
                        ) && (
                          <CustomTableCell align="right">
                            {n.defectCount > 0 ? (
                              <Link
                                to={{
                                  pathname: ["vendor", "mech"].includes(
                                    this.state.table
                                  )
                                    ? `/${this.state.table}/customer/${n.customer}/vehicle/${n.id}`
                                    : `company/vehicle/${n.id}`,
                                  focus: "Def"
                                  // client: { client }
                                }}
                              >
                                {n.defectCount}
                              </Link>
                            ) : (
                              <Typography> {n.defectCount}</Typography>
                            )}
                          </CustomTableCell>
                        )}
                        {this.state.table === "general" && (
                          <CustomTableCell align="right">
                            <Link
                              to={{
                                pathname: `/company/edit/${n.id}`
                              }}
                            >
                              Edit
                            </Link>
                          </CustomTableCell>
                        )}
                        {this.state.table === "general" && (
                          <CustomTableCell align="right">
                            <Typography
                              style={{
                                color: "red",
                                cursor: "pointer"
                              }}
                              onClick={() =>
                                this.setState({ del: n.id, open: true })
                              }
                            >
                              Delete
                            </Typography>
                          </CustomTableCell>
                        )}
                        {this.state.table === "mech" && (
                          <CustomTableCell
                            align="right"
                            style={{
                              color: "purple",
                              cursor: "pointer"
                            }}
                            onClick={() => this.props.handleInspectVehicle(n)}
                          >
                            Start Inspection
                          </CustomTableCell>
                        )}
                      </TableRow>
                    );
                  })}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <CustomTableCell colSpan={6}>
                    {" "}
                    <div
                      style={{
                        alignContent: "center",
                        justifyContent: "center",
                        marginLeft: "45%",
                        fontSize: 16
                      }}
                    >
                      {" "}
                      No Data{" "}
                    </div>{" "}
                  </CustomTableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </div>
        <TablePagination
          rowsPerPageOptions={[]}
          component="div"
          count={data.length}
          rowsPerPage={tempRowsPerPage}
          page={page}
          backIconButtonProps={{
            "aria-label": "Previous Page"
          }}
          nextIconButtonProps={{
            "aria-label": "Next Page"
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

DataTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(DataTable);



// WEBPACK FOOTER //
// ./src/customers/DataTable.js